<template>
  <j-error-alert
    v-if="error"
    v-model="error"
    v-on:retry="refreshData()"
  />
  <v-data-table
    v-else
    :headers="headers"
    :items="items"
    :loading="isLoading"
    
    :page.sync="page"
    :items-per-page.sync="itemsPerPage"
    :hide-default-footer="false"
    :server-items-length="itemsCount"
    @page-count="pageCount = $event"
    :footer-props="{
      'items-per-page-options': [5, 10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true,
    }"

    :sort-by="sortBy"
    v-on:update:sort-by="updateSortBy"
    :sort-desc="sortDesc"
    v-on:update:sort-desc="updateSortDesc"
    :multi-sort="true"

    :expanded.sync="expanded"
    show-expand

    @click:row="(e) => $router.push({ name: 'item-view', params: { itemId: e.id } })"

    mobile-breakpoint="100"

    class="table"
    :class="{
      narrow: narrow
    }"
  >

    <!-- TABLE TOP HEADER -->
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>All Records</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="filterDialogVisible"
          width="300"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
            >
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              Not Implemented
            </v-card-title>

            <v-card-text>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="filterDialogVisible = false"
              >
                Apply
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn
          icon
          v-on:click="refreshData"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-toolbar>
    </template>

    <!-- HEADER ROW -->
    <!-- <template v-slot:header="{ props: { headers, options: { sortBy, sortDesc, multiSort } } }">
      <thead>
        <th
          v-for="header in headers"
          :key="header.value"
          :class="[ `align--${header.align || 'left'}` ]"
        >
          {{ header.text }}
          <template
            v-if="sortBy.includes(header.value)"
          >
            <span v-if="multiSort">
              {{ sortBy.indexOf(header.value) }}
            </span>
            <span v-text="sortDesc[sortBy.indexOf(header.value)]" />
          </template>
        </th>
      </thead>
    </template> -->

    <!-- ITEM.DATE -->
    <template v-slot:[`item.date`]="{ item, value }">
      <div class="d-flex justify-center align-center">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="d-flex justify-center align-center">
              <span v-text="value" />
              <v-icon v-text="item.timeGroup.icon" class="ml-1" />
            </div>
          </template>
          <div class="d-flex">
            <v-icon dark large v-text="item.timeGroup.icon" color="" class="mr-2" />
            <div class="d-flex flex-column justify-center align-center">
              <div>{{ value | long-date }}</div>
              <div v-text="item.timeGroup.name" />
            </div>
          </div>
        </v-tooltip>
      </div>
    </template>
    
    <!-- ITEM.POSITION -->
    <template v-slot:[`item.positions[0].abbr`]="{ item }">
      <!-- {{ item.positions.map(z => z.abbr).join(', ') }} -->
      <ul class="comma-list">
        <v-tooltip
          v-for="(position, i) in item.positions"
          :key="i"
          bottom
        >
          <template v-slot:activator="{ on }">
            <li v-on="on">{{ position.abbr }}</li>
          </template>
          <span>{{ position.name }}</span>
        </v-tooltip>
      </ul>
    </template>

    <!-- ITEM.LOCATION -->
    <template v-slot:[`item.location.abbr`]="{ item, value }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span v-on="on">
            {{ value }}
            <template v-if="item.place">[<span v-text="item.place.abbr" />]</template>
          </span>
        </template>
        <div class="d-flex flex-column justify-center align-center">
          <span>{{ item.location.name }}</span>
          <span v-if="item.place" v-text="item.place.name" />
        </div>
      </v-tooltip>
    </template>

    <template v-slot:[`item.rating`]="{ value }">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-icon v-text="ratingIcons[value]" v-on="on" />
        </template>
        <div class="d-flex flex-row justify-center align-center">
          <!-- <v-icon v-text="ratingIcons[value]" large dark /> -->
          <v-icon v-text="'mdi-star'" dark small />
          <span class="ml-1" style="font-size: 20px;">{{ value }}</span>
        </div>
      </v-tooltip>
    </template>
    
    <!-- EXPANDED COLUMN -->
    <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }">
      <v-tooltip v-if="item.note" left>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            v-on="on"
            v-on:click.stop="expand(!isExpanded)"
          >
            <v-icon v-text="'mdi-information'" />
          </v-btn>
        </template>
        <div>{{ item.note }}</div>
      </v-tooltip>
      
    </template>

    <!-- EXPANDED ROW -->
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">{{ item.note }}</td>
    </template>

    <!-- FOOTER (PAGINATION)
    <template v-slot:footer>
      <div class="text-center pa-4">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </template> -->

    <!-- <template v-slot:footer>
      <div class="text-center pa-4">
        <div>{{ sortBy.join(' | ') }}</div>
        <div>{{ expanded }}</div>
      </div>
    </template> -->
  </v-data-table>
</template>

<script>
// import api from '@/helpers/api'
import JErrorAlert from '@/ui/controls/JErrorAlert'
import ratingIcons from '@/assets/ratingIcons'

export default {
  components: {
    JErrorAlert,
  },
  // props: {
  //   // items: Array,
  //   narrow: Boolean,
  // },
  data() {
    return {
      headers: [
        { text: 'Date', value: 'date', align: 'center', },
        { text: 'Type', value: 'type.abbr', align: 'center', },
        { text: 'Pos', value: 'positions[0].abbr', align: 'center', sortable: false },
        { text: 'Loc', value: 'location.abbr', align: 'center', },
        { text: 'Rate', value: 'rating', align: 'center', },

        { text: '', value: 'data-table-expand' },
      ],

      isLoading: false,
      error: undefined,

      // page: 1,
      pageCount: 0,
      // itemsPerPage: 10,

      // sortBy: ['date', 'timeGroup.order'], //, 'createdAt'],
      // sortBy: ['date'], //, 'createdAt'],
      // sortDesc: [true, true], //, true],
      // sortDesc: [true],

      items: [],
      itemsCount: 0,

      expanded: [],

      filterDialogVisible: false,
    }
  },
  computed: {
    page: {
      get() {
        return parseInt(this.$route.query.page ?? 1)
      },
      set(value) {
        this.replaceRouteQuery({ page: value })
      },
    },
    itemsPerPage: {
      get() {
        return parseInt(this.$route.query.perPage ?? 10)
      },
      set(value) {
        this.replaceRouteQuery({ perPage: value })
      },
    },
    sortBy() {
      return this.getSortBy(this.$route.query.sort)
    },
    sortDesc() {
      return this.getSortDesc(this.$route.query.sort)
    },
    // sortBy: {
    //   get() {
    //     console.log('sortBy.get()', this.$route.query.sort, this.getSortBy(this.$route.query.sort))
    //     return this.$route.query.sort ? this.getSortBy(this.$route.query.sort) : ['date']
    //   },
    //   set(value) {
    //     const sortStr = this.getSortStr(value, this.sortDesc)
    //     console.log('sortBy.set(', value, ')', sortStr)
    //     this.replaceRouteQuery({ sort: sortStr })
    //   },
    // },
    // sortDesc: {
    //   get() {
    //     console.log('sortDesc.get()', this.$route.query.sort, this.getSortDesc(this.$route.query.sort))
    //     return this.$route.query.sort ? this.getSortDesc(this.$route.query.sort) : [true]
    //   },
    //   set(value) {
    //     const sortStr = this.getSortStr(this.sortBy, value)
    //     console.log('sortDesc.set(', value, ')', sortStr)
    //     this.replaceRouteQuery({ sort: sortStr })
    //   },
    // },


    narrow() {
      return this.$vuetify.breakpoint.smAndDown
    },
    // sortStr() {
    //   return this.getSortStr(this.sortBy, this.sortDesc)
    // },
    url() {
      return this.$api.resolvePath(['items/all', this.page || 1], { itemsPerPage: this.itemsPerPage || 20, sort: this.getSortStr(this.sortBy, this.sortDesc) })
    },
  },
  watch: {
    url(newVal) {
      this.fetchData(newVal)
    },
  },
  created() {
    this.ratingIcons = ratingIcons
  },
  mounted() {
    this.fetchData(this.url)
  },
  methods: {
    updateSortBy(value) {
      // console.log('updating sortBy', value)
      this.$nextTick()
        .then(() => {
          const sortStr = this.getSortStr(value, this.sortDesc)
          if (this.$route.query.sort != sortStr) this.replaceRouteQuery({ sort: sortStr })
        })
    },
    updateSortDesc(value) {
      // console.log('updating sortDesc', value)
      this.$nextTick()
        .then(() => {
          const sortStr = this.getSortStr(this.sortBy, value)
          if (this.$route.query.sort != sortStr) this.replaceRouteQuery({ sort: sortStr })
        })
    },
    getSortStr(sortBy, sortDesc) {
      // console.log('getSortStr', sortBy, sortDesc)
      return sortBy.map((s, i) => {
        // console.log(s, i, sortDesc[i])
        return `${s}:${sortDesc[i] ? 1 : 0}`
      }).join(',')
    },
    getSortBy(sortStr) {
      return (sortStr || 'date:1')
        .split(',')
        .map(sortStrItem => sortStrItem.split(':'))
        .map(sortArrItem => sortArrItem[0])
        .map(z => z.trim())
    },
    getSortDesc(sortStr) {
      return (sortStr || 'date:1')
        .split(',')
        .map(sortStrItem => sortStrItem.split(':'))
        .map(sortArrItem => sortArrItem.length >= 2 ? sortArrItem[1] : 0)
        .map(ascDescInd => Number(ascDescInd) ? true : false)
        // .map(z => z.trim())
    },
    replaceRouteQuery(newOpts) {
      this.$router.replace(
        Object.assign({}, this.$route, { query: Object.assign({}, this.$route.query, newOpts) })
      )
    },
    refreshData() {
      this.fetchData(this.url)
    },
    fetchData(url) {
      this.isLoading = true
      this.error = undefined
      console.log('fetching:', url)
      // fetch(url)
      this.$api.get(url)
        .then(res => {
          console.log(res)
          return res
        })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          this.itemsCount = data.count
          this.items = data.rows
        })
        .catch(err => {
          console.error(err)
          this.error = err
        })
        .finally(() => this.isLoading = false)
    }
  },
}
</script>

<style lang="scss" scoped>
.v-data-table.table {
  ::v-deep {
    // thead {
    //   th {
    //     &.align- {
    //       &-center {
    //         text-align: center;
    //       }

    //       &-right {
    //         text-align: right;
    //       }
    //     }
    //   }
    // }

    tbody {
      tr {
        cursor: pointer;
      }
    }
  }

  &.narrow ::v-deep {
    td,
    th {
      padding: 0 4px;
    }
  }
}
</style>